import { forwardRef } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

import { Button } from '@bonusly/ds-button';

import { useDatePickerContext } from '../context';

type DateRangeOptionProps = PropsWithChildren & {
	startDate: Date;
	endDate: Date;
};

export const DateRangeOption = forwardRef<DateRangeOptionProps, 'button'>(({ startDate, endDate, ...rest }, ref) => {
	const { setRange } = useDatePickerContext();

	if (!setRange) {
		throw new TypeError('DateRangeOption must be a child of DateRangeSelector');
	}

	return (
		<Button colorScheme="secondary" variant="ghost" onClick={() => setRange([startDate, endDate])} ref={ref} w="full" justifyContent="flex-start" {...rest} />
	);
});
